import React, { Component } from 'react';
import {
	Button,
} from '@material-ui/core';
import { hasFeature } from '../index';

class ButtonWithPermissions extends Component {
	render() {
		const props = { ...this.props };
		if (hasFeature(this.props) === false) {
			props.disabled = true;
		}

		return (<Button {...props} />);
	}
}

export default ButtonWithPermissions;



// WEBPACK FOOTER //
// ./src/components/Features/components/Button.js